import css from "@styled-system/css";
import styled from "styled-components";

export const Span = styled.span`
  display: block;

  ${(props) => css({ marginBottom: props.$height, marginRight: props.$width })}
`;
